import React from 'react';
import { PATHS } from '@constants';
import Button from '@components/Button';
import Logo from '@components/Logo';
import notFoundImage from '@img/not-found.png';
import './style.scss';

const NotFound = () => (
  <div className='not-found'>
    <div className='row'>
      <div className='column sm-12'>
        <div className='not-found__wrap text-center'>
          <div className='not-found__logo'>
            <Logo />
          </div>
          <div className='not-found__content'>
            <div className='not-found__number'>4</div>
            <div className='not-found__img'>
              <img width={221} height={226} src={notFoundImage} alt='Not Found' />
              <div className='not-found__text'>Page not found</div>
            </div>
            <div className='not-found__number'>4</div>
          </div>
          <Button
            className='not-found__btn field-text tablet-field-text mobile-field-text'
            theme='main'
            title='Back to home'
            size='md'
            linkTo={PATHS.HOME}
          />
        </div>
      </div>
    </div>
  </div>
);

export default NotFound;
